import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

export interface SubmitContactFormDto {
  firstName: string;
  lastName: string;
  company?: string;
  email: string;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class ApiContactFormService {
  private readonly urlPath = '/v1/contact-form';

  constructor(private readonly httpClient: HttpClient) {}

  public async submit(options: SubmitContactFormDto): Promise<void> {
    const response$ = this.httpClient.post<void>(
      environment.apiBaseUrl + this.urlPath + '/submit',
      options,
    );
    return lastValueFrom(response$);
  }
}
